import { render, staticRenderFns } from "./IndicationTempV2.vue?vue&type=template&id=1363eec8&scoped=true"
import script from "./IndicationTempV2.vue?vue&type=script&lang=js"
export * from "./IndicationTempV2.vue?vue&type=script&lang=js"
import style0 from "./IndicationTempV2.vue?vue&type=style&index=0&id=1363eec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363eec8",
  null
  
)

export default component.exports